<template>
  <div class="SignInPage">
    <ShortNavbar class="Navbar" />

    <section id="login" class="section">
      <div class="container">
        <div class="AuthForm">
          <h2 class="Title">{{ $t("pages.login.title") }}</h2>

          <div class="Fields">
            <input
              v-model="email"
              :class="{
                NewInput: true,
                incorrect: emailMask === 'notValid',
              }"
              type="text"
              :placeholder="$t('pages.login.inputs.email')"
            />
            <input
              v-model="pass"
              class="NewInput"
              type="password"
              :placeholder="$t('pages.login.inputs.password')"
            />
          </div>

          <span
            :class="{
              AuthBtn: true,
              active: true,
            }"
            @click="login"
            >{{ $t("pages.login.buttons.login") }}</span
          >

          <span class="ErrorMSG">{{ $t(msg) }}</span>
        </div>
      </div>
    </section>

    <GeneralFooter class="NavbarDown" />
  </div>
</template>

<script>
import ShortNavbar from "@/components/ShortNavbar";
import GeneralFooter from "@/components/Footer";

import { getUserRegistrationFields } from "@/api/registration_info.js";
import { mapMutations } from "vuex";
import { login } from "@/api/auth.js";
import { findById } from "@/api/user.js";

export default {
  components: {
    GeneralFooter,
    ShortNavbar,
  },
  data() {
    return {
      email: "",
      pass: "",
      msg: "",
    };
  },
  methods: {
    ...mapMutations("auth", ["SET_USER"]),
    async getUser(id, newbie) {
      let findUserResponse = await findById(id);
      this.SET_USER(findUserResponse.data);

      if (findUserResponse.data?.role?.name === "admin") {
        this.$router.push("/admin");
        return 0;
      }

      const hasParentCompany =
        findUserResponse.data?.parent_company?.length > 0;
      if (hasParentCompany) {
        this.$router.push("/org/profile");
        return 0;
      }

      if (
        findUserResponse.data.hasOwnProperty("organization") &&
        findUserResponse.data.organization.length > 0
      ) {
        this.$router.push("/org/profile");
      } else {
        if (newbie) {
          this.$router.push("/registration/user-info");
        } else {
          await this.getUserRegData(id);
          await this.getUniverAndRegion(id);

          let hasNullValues =
            this.sourceData.region == null ||
            this.sourceData.vuz == null ||
            this.sourceData.course == null ||
            this.sourceData.goal == null ||
            this.sourceData.source == null;

          if (hasNullValues) {
            this.$router.push("/registration/user-info");
          } else {
            this.$router.push("/beta/profile");
          }
        }
      }
    },
    async login() {
      if (this.emailMask === "notValid") {
        this.msg = 'pages.login.msg.error.email';
        return 0;
      }

      try {
        const credentials = {
          email: this.email,
          password: this.pass,
        };
        const response = await login(credentials);
        const token = response.token;
        const user = response.user;
        this.$store.dispatch("auth/login", { token, user });
        this.getUser(user.id, false);
      } catch (error) {
        this.msg = error.response.data.message;
      }
    },

    async getUserRegData(__userID) {
      let getUserRegistrationFieldsResponse = await getUserRegistrationFields(
        __userID
      );

      if (getUserRegistrationFieldsResponse != null) {
        this.sourceData.course =
          getUserRegistrationFieldsResponse.data.lvl || null;

        this.sourceData.goal =
          getUserRegistrationFieldsResponse.data.goals.length > 0 || null;

        this.sourceData.source =
          getUserRegistrationFieldsResponse.data.sources.length > 0 || null;
      }
    },
    async getUniverAndRegion(__userID) {
      let RegVuzResponse = await getRegionAndUniver(__userID);
      let MapUniver = RegVuzResponse?.data?.MapRegion;

      if (MapUniver == null || MapUniver?.UsersChoosedUniver == null) {
        return 0;
      }

      this.sourceData.region =
        MapUniver.UsersChoosedUniver.region.name ||
        MapUniver.region_other ||
        null;

      this.sourceData.vuz =
        MapUniver.UsersChoosedUniver.id || MapUniver.univer_other || null;
    },
  },
  computed: {
    emailMask() {
      if (this.email === "") {
        return "isAwaiting";
      }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.email.match(emailRegex)) {
        return "valid";
      } else {
        return "notValid";
      }
    },
  },
};
</script>

<style scoped>
.Navbar:deep(.rpart > .btn) {
  display: none;
}

.ErrorMSG {
  position: relative;
  width: 320px;
  max-width: 100%;

  font-family: "Involve";
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  color: #dc3545;
}

.NewInput::placeholder {
  font-family: "Involve";
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  color: #666666;
}
.NewInput {
  position: relative;
  display: block;

  padding: 15.5px 16px;

  width: 320px;
  max-width: 100%;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  color: #1a1a1a;

  border-radius: 8px;
  border: 1px solid #666666;
  outline: none;
}
.NewInput.incorrect {
  border: 1px solid #dc3545;
}
.AuthBtn {
  position: relative;
  display: block;

  cursor: pointer;

  padding: 12px 6px;

  width: 100%;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;

  text-align: center;

  border-radius: 8px;
  color: #666666;
  background-color: #d9d9d9;
}
.AuthBtn.active {
  background-color: #f9d773;
  color: #1a1a1a;
}
.Fields {
  position: relative;
  display: flex;

  margin-bottom: 8px;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
}
.Title {
  position: relative;
  display: inline;

  margin-bottom: 8px;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}
.AuthForm {
  position: relative;
  display: flex;

  padding: 40px;
  margin: 0% auto;
  margin-top: 0px;
  margin-bottom: 246px;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;

  border-radius: 24px;
  background-color: #ffffff;
}

.Navbar {
  top: 0;
  position: relative;
  padding: 30px 0%;
}
.NavbarDown {
  margin-top: auto;
}
.SignInPage {
  position: relative;
  display: flex;

  width: 100%;
  min-height: 100svh;

  flex-direction: column;

  overflow: hidden;
  background: #fff;
}
.container {
  width: 100%;
  max-width: 1168px; /* 1128px content + 20px padding on each side */
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
}

.section {
  padding-top: 60px;
  padding-bottom: 60px;
}

@media (max-width: 992px) {
  .NewInput,
  .ErrorMSG {
    width: auto;
  }

  .AuthForm,
  .Fields {
    width: 100%;
  }

  .AuthForm {
    margin: 50px auto;
  }
  .section {
    padding: 20px 0%;
  }

  .Navbar {
    top: 0;
    position: relative;
    padding: 15px 0%;
  }
}
</style>
